// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const AiApiSpec_addToModelTrainingQueueCallbackSchema = z.object({
  timely_user_id: z.number().int().min(1).describe("The Timely user.id"),
  timely_account_id: z.number().int().min(1).describe("The Timely account.id"),
  message: z.coerce.string().describe("Additional information about the event").nullish(),
  event: z.enum(["training_requested", "training_pending", "training_running", "training_complete", "training_failed", "training_data_insufficient"]),
  model_last_trained_at: z.optional(z.string().datetime({ offset: true })),
});
